export default __webpack_public_path__ + "static/media/25120415.e0ee7afc.jpg";